/**
 * La Caviare — Waitlist  v8
 *
 * Works with BOTH:
 *  (A) New approach: #WaitlistModal pre-rendered by waitlist-form.liquid section
 *  (B) Legacy approach: #WaitlistCustomerForm already in body from theme.liquid
 *
 * For (B), the existing server-rendered form (with all Shopify security tokens
 * already in place) is moved into a dynamically-created modal overlay.
 * A genuine user click on the "Notify Me" submit button satisfies Shopify captcha.
 *
 * Flow:
 *  1. CSS: "SOLD OUT" → "JOIN THE WAITLIST" on disabled buy button
 *  2. pointerdown on disabled button → modal opens
 *  3. User fills email and clicks "Notify Me" (real click on real submit button)
 *  4. Form POSTs to /contact  → Shopify creates Customer with tags, redirects to return_to
 *  5. On reload: sessionStorage flag → modal auto-opens showing success message
 */
(function () {
  'use strict';

  var WL_KEY = 'wl-submitted';

  /* ── Detect page type ─────────────────────────────────────────────────── */
  var modal      = document.getElementById('WaitlistModal');
  var legacyForm = document.getElementById('WaitlistCustomerForm');

  if (!modal && !legacyForm) return; // Not a waitlist product page

  /* ── Build modal from legacy form if the new snippet isn't rendered ────── */
  if (!modal && legacyForm) {
    modal = buildLegacyModal(legacyForm);
    if (!modal) return;
  }

  /* ── Mark page so CSS rules activate ─────────────────────────────────── */
  document.documentElement.classList.add('wl-page');

  /* ── Fix field names: customer[*] → contact[*] to match Shopify's email-signup ─ */
  var modalForm = modal.querySelector('form');
  if (modalForm) {
    var fieldsToRename = [
      { from: 'customer[email]', to: 'contact[email]' },
      { from: 'customer[tags]',  to: 'contact[tags]' }
    ];
    fieldsToRename.forEach(function (f) {
      var el = modalForm.querySelector('[name="' + f.from + '"]');
      if (el) el.name = f.to;
    });
  }

  /* ── Wire up return_to so Shopify redirects back after form submit ─────── */
  if (modalForm && !modalForm.querySelector('[name="return_to"]')) {
    var ri   = document.createElement('input');
    ri.type  = 'hidden';
    ri.name  = 'return_to';
    ri.value = window.location.pathname;
    modalForm.insertBefore(ri, modalForm.firstChild);
  }

  if (modalForm) {
    modalForm.addEventListener('submit', function () {
      try { sessionStorage.setItem(WL_KEY, '1'); } catch (e) {}
    });
  }

  /* ── Open / Close ─────────────────────────────────────────────────────── */
  function openModal() {
    modal.setAttribute('aria-hidden', 'false');
    var emailInput = modal.querySelector('[name="contact[email]"]');
    if (emailInput) setTimeout(function () { emailInput.focus(); }, 100);
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
  }

  modal.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-waitlist-close]')) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) &&
        modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });

  /* ── Post-submit: auto-open on success ────────────────────────────────── */
  var hasServerState = modal.querySelector('.waitlist-modal__success') ||
                       modal.querySelector('.waitlist-modal__error');

  var hasSessionFlag = false;
  try { hasSessionFlag = !!sessionStorage.getItem(WL_KEY); } catch (e) {}
  if (hasSessionFlag) {
    try { sessionStorage.removeItem(WL_KEY); } catch (e) {}
    showJsSuccess(modal);
  }

  if (hasServerState || hasSessionFlag) {
    setTimeout(openModal, 250);
  }

  /* ── Intercept click on disabled "SOLD OUT" / "JOIN THE WAITLIST" button ─ */
  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest ? e.target.closest('.add-to-cart-button') : null;

    if (!btn) {
      /* Fallback: check if the pointer is over any disabled buy button's rect */
      var allBtns = document.querySelectorAll('.add-to-cart-button[disabled]');
      for (var i = 0; i < allBtns.length; i++) {
        var rect = allBtns[i].getBoundingClientRect();
        if (rect.width && rect.height &&
            e.clientX >= rect.left && e.clientX <= rect.right &&
            e.clientY >= rect.top  && e.clientY <= rect.bottom) {
          btn = allBtns[i];
          break;
        }
      }
      if (!btn) return;
    }

    if (!btn.disabled) return;
    if (!document.documentElement.classList.contains('wl-page')) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    openModal();
  }, true);

  /* ── Styles ──────────────────────────────────────────────────────────── */
  var style = document.createElement('style');
  style.textContent =

    /* Button: make disabled button look clickable */
    'html.wl-page .shopify-product-form .add-to-cart-button[disabled],' +
    'html.wl-page sticky-add-to-cart .add-to-cart-button[disabled]{' +
      'opacity:1!important;cursor:pointer!important;}' +

    /* Hide ALL text inside the button (works with or without nested spans) */
    'html.wl-page .shopify-product-form .add-to-cart-button[disabled] .add-to-cart-text__content,' +
    'html.wl-page sticky-add-to-cart .add-to-cart-button[disabled] .add-to-cart-text__content{' +
      'font-size:0!important;line-height:0!important;overflow:hidden!important;}' +

    /* Show replacement text via ::after on the container (single source, no duplication) */
    'html.wl-page .shopify-product-form .add-to-cart-button[disabled] .add-to-cart-text__content::after,' +
    'html.wl-page sticky-add-to-cart .add-to-cart-button[disabled] .add-to-cart-text__content::after{' +
      'content:"JOIN THE WAITLIST";' +
      'font-size:0.85rem;line-height:normal;letter-spacing:0.1em;}' +

    /* Hide cart icon and quantity display */
    'html.wl-page .shopify-product-form .add-to-cart-button[disabled] .add-to-cart-icon,' +
    'html.wl-page sticky-add-to-cart .add-to-cart-button[disabled] .add-to-cart-icon{display:none!important;}' +

    'html.wl-page .shopify-product-form .add-to-cart-button[disabled] [ref="quantityDisplay"],' +
    'html.wl-page sticky-add-to-cart .add-to-cart-button[disabled] [ref="quantityDisplay"]{display:none!important;}' +

    /* Suppress form error banners on waitlist pages */
    'html.wl-page .shopify-product-form [role="alert"],' +
    'html.wl-page .shopify-product-form .product-form__error-message,' +
    'html.wl-page .shopify-product-form .form__message--error,' +
    'html.wl-page .shopify-product-form .errors{display:none!important;}' +

    /* Modal overlay */
    '.waitlist-modal{position:fixed;inset:0;z-index:9999;display:flex;' +
      'align-items:center;justify-content:center;' +
      'opacity:0;visibility:hidden;transition:opacity .2s ease,visibility .2s ease}' +
    '.waitlist-modal[aria-hidden="false"]{opacity:1;visibility:visible}' +
    '.waitlist-modal__overlay{position:absolute;inset:0;background:rgba(0,0,0,.5)}' +
    '.waitlist-modal__content{position:relative;background:#fff;padding:2rem;' +
      'max-width:480px;width:calc(100% - 2rem);border-radius:4px;z-index:1}' +
    '.waitlist-modal__close{position:absolute;top:1rem;right:1rem;' +
      'background:none;border:none;cursor:pointer;padding:4px;line-height:0;color:inherit}' +
    '.waitlist-modal__title{font-size:1.25rem;margin:0 0 .75rem;font-weight:600;letter-spacing:0.04em}' +
    '.waitlist-modal__description{margin:0 0 1.5rem;color:#555;font-size:0.875rem;line-height:1.7}' +
    '.waitlist-modal__field{display:flex;gap:.5rem;flex-wrap:wrap}' +
    '.waitlist-modal__input{flex:1;min-width:0;padding:.75rem 1rem;' +
      'border:1px solid #ccc;border-radius:2px;font-size:1rem;font-family:inherit}' +
    '.waitlist-modal__submit{padding:.75rem 1.5rem;background:#000;color:#fff;' +
      'border:none;cursor:pointer;border-radius:2px;' +
      'font-size:.875rem;letter-spacing:.08em;white-space:nowrap;font-family:inherit}' +
    '.waitlist-modal__success{padding:.5rem 0;font-size:0.95rem;line-height:1.7}' +
    '.waitlist-modal__error{color:#c00;font-size:.875rem;margin-bottom:.75rem}' +

    /* Hide crossed-out lines on variant swatches for waitlist products */
    'html.wl-page .variant-option__strikethrough{display:none!important;}';

  document.head.appendChild(style);

  /* ═══════════════════════════════════════════════════════════════════════
     buildLegacyModal()
     Called when #WaitlistModal is absent but #WaitlistCustomerForm exists
     (old waitlist code rendered in theme.liquid).
     Moves the server-rendered form into a newly created modal overlay.
     ═════════════════════════════════════════════════════════════════════== */
  function buildLegacyModal(form) {
    /* 1. Style the email input to be visible */
    var emailInput = form.querySelector('[name="customer[email]"]') ||
                     form.querySelector('[name="contact[email]"]');
    if (emailInput) {
      emailInput.className    = 'waitlist-modal__input';
      emailInput.placeholder  = 'Enter your email';
      emailInput.autocomplete = 'email';
      emailInput.required     = true;
      emailInput.removeAttribute('style');
    }

    /* 2. Create field row: [email input] [submit button] */
    var fieldDiv = document.createElement('div');
    fieldDiv.className = 'waitlist-modal__field';
    if (emailInput) {
      var parent = emailInput.parentNode;
      if (parent === form) {
        form.insertBefore(fieldDiv, emailInput);
      } else {
        parent.insertBefore(fieldDiv, emailInput);
      }
      fieldDiv.appendChild(emailInput);
    }
    var submitBtn = document.createElement('button');
    submitBtn.type      = 'submit';
    submitBtn.className = 'waitlist-modal__submit button';
    submitBtn.textContent = 'Notify Me';
    fieldDiv.appendChild(submitBtn);

    /* 3. Set sessionStorage flag on submit */
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem(WL_KEY, '1'); } catch (e) {}
    });

    /* 5. Assemble modal DOM */
    var overlayDiv = document.createElement('div');
    overlayDiv.className = 'waitlist-modal__overlay';
    overlayDiv.setAttribute('data-waitlist-close', '');

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'waitlist-modal__close';
    closeBtn.setAttribute('data-waitlist-close', '');
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none">' +
      '<path d="M14 4L4 14M4 4l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    var titleEl = document.createElement('h2');
    titleEl.className   = 'waitlist-modal__title';
    titleEl.textContent = 'Join the Waitlist';

    var descEl = document.createElement('p');
    descEl.className   = 'waitlist-modal__description';
    descEl.textContent = 'The availability of Almas is extremely rare. We offer a waitlist for its allocation to clients, allowing them the chance to be notified once it can be offered.';

    var bodyDiv = document.createElement('div');
    bodyDiv.className = 'waitlist-modal__body';
    bodyDiv.appendChild(titleEl);
    bodyDiv.appendChild(descEl);
    bodyDiv.appendChild(form); /* Move form into the modal body */

    var contentDiv = document.createElement('div');
    contentDiv.className = 'waitlist-modal__content';
    contentDiv.appendChild(closeBtn);
    contentDiv.appendChild(bodyDiv);

    var wrapper = document.createElement('div');
    wrapper.id = 'WaitlistModal';
    wrapper.className = 'waitlist-modal';
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.setAttribute('role', 'dialog');
    wrapper.setAttribute('aria-label', 'Join the waitlist');
    wrapper.appendChild(overlayDiv);
    wrapper.appendChild(contentDiv);

    /* 6. Clear old handler's zero-size styles (it's now empty anyway) */
    var handler = document.getElementById('WaitlistHandler');
    if (handler) handler.style.cssText = '';

    document.body.appendChild(wrapper);
    return wrapper;
  }

  /* ═══════════════════════════════════════════════════════════════════════
     showJsSuccess()
     Hides the form, shows a confirmation message inside the modal.
     Used on the post-redirect reload when sessionStorage flag is set.
     ═════════════════════════════════════════════════════════════════════== */
  function showJsSuccess(modal) {
    var form = modal.querySelector('form');
    var title = modal.querySelector('.waitlist-modal__title');
    var desc = modal.querySelector('.waitlist-modal__description');
    if (title) title.style.display = 'none';
    if (desc) desc.style.display = 'none';
    var successDiv = document.createElement('div');
    successDiv.className   = 'waitlist-modal__success';
    successDiv.textContent = "You have been added to the Almas allocation waitlist. We will notify you when this exceptional offering becomes available.";
    if (form) {
      form.style.display = 'none';
      form.parentNode.insertBefore(successDiv, form);
    } else {
      var body = modal.querySelector('.waitlist-modal__body') || modal.querySelector('.waitlist-modal__content');
      if (body) body.appendChild(successDiv);
    }
  }

})();

/* ═══════════════════════════════════════════════════════════════════════
   Badge swap: SOLD OUT → WAITLIST on collection / search / home pages
   For every product card that shows a "SOLD OUT" badge, fetches the
   product JSON and checks for the "Waitlist" tag.  One lightweight
   request per sold-out card (typically 0–2 on the page).
   ═════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var cards = document.querySelectorAll('product-card');
  if (!cards.length) return;

  cards.forEach(function (card) {
    var badge = card.querySelector('.product-badges__badge');
    if (!badge || badge.textContent.trim() !== 'SOLD OUT') return;

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;

    var match = link.href.match(/\/products\/([^?#\/]+)/);
    if (!match) return;

    fetch('/products/' + match[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.tags && data.tags.indexOf('Waitlist') > -1) {
          badge.textContent = 'WAITLIST';
        }
      })
      .catch(function () {});
  });
})();